import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const InviteUserOptionStyled = styled.div`
  display: flex;
  width: 100%;
  gap: 30px;
  align-items: center;
`;

export const UserDetailsText = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  width: 25%;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
`;

export const ExistingTeamMemberText = styled(UserDetailsText)`
  color: ${(props) => props.theme.atlas.semantic.color.action.primary.active};
  margin-left: auto;
  padding-left: 50px;
  width: 25%;
`;

export const UserNameText = styled(UserDetailsText)`
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;
